import styled, { css } from "styled-components";

export const HeaderContainer = styled.header`
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 20;
  display: flex;
  justify-content: stretch;
  pointer-events: none;
  background: rgba(245, 255, 254, 0.62);
  border-bottom: 1px solid rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  box-shadow: 0 14px 30px rgba(10, 96, 89, 0.14);

  ${(props) =>
    props.$aesthetic
      ? css`
          justify-content: stretch;
          background: rgba(255, 255, 255, 0.96);
          border-bottom: 1px solid #d2e5d8;
          backdrop-filter: none;
          box-shadow: none;
        `
      : ""}
`;

export const HeaderInner = styled.div`
  pointer-events: auto;
  width: 100%;
  margin-top: 0;
  min-height: 76px;
  border-radius: 0;
  border: 0;
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  column-gap: 36px;
  padding: 12px clamp(18px, 3.2vw, 42px);

  ${(props) =>
    props.$aesthetic
      ? css`
          width: 100%;
          margin-top: 0;
          min-height: 78px;
          border-radius: 0;
          border: 0;
          background: transparent;
          backdrop-filter: none;
          box-shadow: none;
          grid-template-columns: auto 1fr auto auto;
          column-gap: 30px;
          padding: 14px clamp(18px, 3.8vw, 54px);
        `
      : ""}

  @media (max-width: 991px) {
    grid-template-columns: 1fr auto;
    min-height: 64px;
    padding: 8px 14px;
    width: 100%;
    margin-top: 0;
    border-radius: 0;

    ${(props) =>
      props.$aesthetic
        ? css`
            min-height: 72px;
            padding: 8px 16px;
            width: 100%;
            margin-top: 0;
            border-radius: 0;
          `
        : ""}
  }
`;

export const Brand = styled.button`
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const BrandLogo = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 9px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.42);

  ${(props) =>
    props.$aesthetic
      ? css`
          border: 1px solid #cde1d4;
        `
      : ""}
`;

export const BrandText = styled.div`
  display: grid;
  align-content: center;
`;

export const BrandTitle = styled.div`
  font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
  font-size: clamp(1.04rem, 1.35vw, 1.28rem);
  color: ${(props) => props.pageTheme?.colors?.title || "#0f4a3f"};
  line-height: 0.98;
  text-transform: uppercase;
  letter-spacing: -0.02em;

  ${(props) =>
    props.$aesthetic
      ? css`
          font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
          text-transform: none;
          letter-spacing: -0.01em;
          font-size: clamp(1.02rem, 1.34vw, 1.22rem);
          line-height: 1;
          color: #2f5141;
        `
      : ""}
`;

export const BrandSub = styled.div`
  margin-top: 5px;
  color: ${(props) => props.pageTheme?.colors?.subtitle || "#5a746a"};
  font-size: 0.64rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;

  ${(props) =>
    props.$aesthetic
      ? css`
          margin-top: 6px;
          letter-spacing: 0.16em;
          font-size: 0.64rem;
        `
      : ""}

  @media (max-width: 991px) {
    display: none;
  }
`;

export const DesktopNav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;

  ${(props) =>
    props.$aesthetic
      ? css`
          gap: 6px;
        `
      : ""}

  @media (max-width: 991px) {
    display: none;
  }
`;

export const NavItem = styled.button`
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.36);
  border-radius: 999px;
  padding: 9px 12px;
  color: ${(props) => props.pageTheme?.colors?.text || "#1d5548"};
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition: color 0.22s ease, border-color 0.22s ease, background 0.22s ease, transform 0.22s ease;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 6px;
    height: 1px;
    background: rgba(15, 143, 134, 0.34);
    transform: scaleX(0);
    transform-origin: left center;
    transition: transform 0.22s ease;
  }

  :hover {
    color: ${(props) => props.pageTheme?.colors?.accent || "#0f4339"};
    border-color: rgba(116, 226, 216, 0.54);
    background: rgba(255, 255, 255, 0.72);
    transform: translateY(-1px);
  }

  :hover::after {
    transform: scaleX(1);
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border-radius: 6px;
          padding: 7px 8px;
          border: 1px solid transparent;
          background: transparent;
          backdrop-filter: none;
          font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
          font-size: 0.68rem;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #567668;
          position: relative;
          transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;

          &::after {
            content: "";
            position: absolute;
            left: 8px;
            right: 8px;
            bottom: 4px;
            height: 1px;
            background: rgba(36, 49, 41, 0.5);
            transform: scaleX(0);
            transform-origin: left center;
            transition: transform 0.22s ease;
          }

          :hover {
            background: transparent;
            border-color: transparent;
            color: #2f5141;
            transform: none;
          }

          :hover::after {
            transform: scaleX(1);
          }
        `
      : ""}
`;

export const HeaderCta = styled.button`
  border: 1px solid rgba(15, 143, 134, 0.38);
  border-radius: 999px;
  min-height: 44px;
  padding: 0 18px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #f6fffd;
  cursor: pointer;
  background: linear-gradient(120deg, #0f8f86 0%, #2db8ae 100%);
  box-shadow: 0 12px 24px rgba(15, 143, 134, 0.26);
  transition: background 0.22s ease, color 0.22s ease, transform 0.22s ease, box-shadow 0.22s ease;

  :hover {
    background: linear-gradient(120deg, #0b7e77 0%, #20a79d 100%);
    color: #f4fffd;
    transform: translateY(-1px);
    box-shadow: 0 16px 28px rgba(15, 143, 134, 0.32);
  }

  @media (max-width: 991px) {
    display: none;
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border-radius: 999px;
          min-height: 40px;
          padding: 0 16px;
          font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
          font-size: 0.66rem;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          background: ${props.$secondary ? "transparent" : "#6c9f85"};
          color: ${props.$secondary ? "#4f715f" : "#f7faf8"};
          border: 1px solid ${props.$secondary ? "#b7d0c2" : "#6c9f85"};
          box-shadow: none;

          :hover {
            background: ${props.$secondary ? "#eef7f1" : "#5b8d74"};
            color: ${props.$secondary ? "#3c5b4c" : "#f7faf8"};
            transform: translateY(-1px);
            box-shadow: none;
          }
        `
      : ""}
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 991px) {
    display: none;
  }
`;

export const HeaderSwitch = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border-radius: 999px;
  background: rgba(6, 22, 14, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.62);

  ${(props) =>
    props.$aesthetic
      ? css`
          background: rgba(6, 22, 14, 0.08);
          border: 1px solid #cde1d4;
        `
      : ""}
`;

export const HeaderSwitchButton = styled.button`
  min-height: 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0 11px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${(props) => (props.$active ? "#ffffff" : "#3d5d4f")};
  background: ${(props) => (props.$active ? "#6c9f85" : "transparent")};
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;

  :hover {
    transform: translateY(-1px);
    background: ${(props) => (props.$active ? "#5b8d74" : "rgba(108, 159, 133, 0.14)")};
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border: 1px solid
            ${props.$active ? "rgba(108, 159, 133, 0.85)" : "rgba(108, 159, 133, 0.32)"};
        `
      : ""}
`;

export const HeaderSwitchIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.86rem;
`;

export const HeaderSwitchLabel = styled.span`
  @media (max-width: 1260px) {
    display: none;
  }
`;

export const MobileToggle = styled.button`
  display: none;

  @media (max-width: 991px) {
    display: inline-flex;
    width: 44px;
    height: 44px;
    border: 1px solid rgba(255, 255, 255, 0.72);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.62);
    backdrop-filter: blur(10px);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;

    ${(props) =>
      props.$aesthetic
        ? css`
            border-radius: 12px;
            width: 44px;
            height: 44px;
            background: #f8fdf9;
            border: 1px solid #cde1d4;
            backdrop-filter: none;
            box-shadow: none;
          `
        : ""}
  }

  span {
    width: 20px;
    height: 2px;
    background: ${(props) => props.pageTheme?.colors?.accent || "#115345"};
    border-radius: 3px;
    display: block;
  }
`;

export const MobileMenuOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(5, 21, 19, 0.34);
  z-index: 18;
  opacity: ${(props) => (props.open ? 1 : 0)};
  pointer-events: ${(props) => (props.open ? "auto" : "none")};
  transition: opacity 0.24s ease;

  ${(props) =>
    props.$aesthetic
      ? css`
          background: rgba(19, 28, 23, 0.28);
        `
      : ""}
`;

export const HeaderMobileMenu = styled.aside`
  position: fixed;
  top: 72px;
  right: 9px;
  left: 9px;
  z-index: 19;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px);
  box-shadow: 0 20px 36px rgba(11, 92, 85, 0.22);
  padding: 10px;
  transform: ${(props) => (props.open ? "translateY(0)" : "translateY(-16px)")};
  opacity: ${(props) => (props.open ? 1 : 0)};
  pointer-events: ${(props) => (props.open ? "auto" : "none")};
  transition: transform 0.24s ease, opacity 0.24s ease;

  @media (min-width: 992px) {
    display: none;
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          top: 72px;
          right: 9px;
          left: 9px;
          border-radius: 12px;
          border: 1px solid #cde1d4;
          background: #f8fdf9;
          backdrop-filter: none;
          box-shadow: 0 8px 16px rgba(24, 36, 29, 0.08);
        `
      : ""}
`;

export const MobileTop = styled.div`
  padding: 10px 10px 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid ${(props) => props.pageTheme?.colors?.accentBorder || "rgba(17, 83, 69, 0.1)"};
  color: ${(props) => props.pageTheme?.colors?.title || "#0f4a3f"};
  font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.74rem;

  ${(props) =>
    props.$aesthetic
      ? css`
          font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          font-size: 0.76rem;
        `
      : ""}
`;

export const HeaderMobileItem = styled.button`
  width: 100%;
  min-height: 48px;
  padding: 0 14px;
  border: 0;
  border-radius: 14px;
  background: ${(props) =>
    props.button
      ? "linear-gradient(120deg, #0f8f86 0%, #2db8ae 100%)"
      : "rgba(255, 255, 255, 0.42)"};
  color: ${(props) => (props.button ? "#ffffff" : props.pageTheme?.colors?.text || "#1c5548")};
  text-align: left;
  font-size: 0.76rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: ${(props) => (props.button ? 700 : 600)};
  cursor: pointer;
  margin-bottom: 4px;
  transition: transform 0.2s ease, background 0.2s ease;

  :hover {
    background: ${(props) =>
      props.button
        ? "linear-gradient(120deg, #0b7e77 0%, #20a79d 100%)"
        : "rgba(255, 255, 255, 0.74)"};
    transform: translateX(2px);
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border-radius: 12px;
          font-size: 0.76rem;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
          background: ${props.button ? "#6c9f85" : "transparent"};
          border: 1px solid ${props.button ? "#6c9f85" : "#cde1d4"};
          color: ${props.button ? "#f7faf8" : "#567668"};

          :hover {
            background: ${props.button ? "#5b8d74" : "transparent"};
            transform: none;
          }
        `
      : ""}
`;
